import { v4 as uuidv4 } from 'uuid';

import { accountsBalancesActions, accountsBalancesTypes } from 'app-components/flux/accounts-balances';
import store from 'app-components/utils/redux-store';

import { mergeMintImportSharedState } from './mintImportSharedState';

const importBalances = async (fileJS, simplifiAccountsByMintId) => {
  const key = 'BALANCES';
  let results = false;

  try {
    const simplifiBalances = Object.entries(fileJS.trends).reduce((balances, [mintAccountId, mintAccountTrends]) => {
      const accountId = simplifiAccountsByMintId.get(mintAccountId)?.id;
      if (assert(accountId, 'account not found for mintAccountId', { mintAccountId })) {
        return balances.concat(
          mintAccountTrends.map((mintAccountTrend) =>
            accountsBalancesTypes.mkAccountsBalance({
              clientId: uuidv4().toUpperCase(),
              accountId,
              balanceType: 'CURRENT',
              balanceAmount: mintAccountTrend.amount,
              balanceOn: mintAccountTrend.date,
            }),
          ),
        );
      }
      return balances;
    }, []);

    mergeMintImportSharedState({ key, progress: 10 });

    const totalLength = simplifiBalances.length;
    const chunkSize = 150;
    let chunk = simplifiBalances.splice(0, chunkSize);
    let index = 0;
    while (chunk.length) {
      // eslint-disable-next-line no-await-in-loop,@typescript-eslint/no-loop-func
      await new Promise((resolve, reject) => {
        store.dispatch(accountsBalancesActions.batchAccountsBalances(chunk, { resolve, reject }));
      });

      index += chunkSize;
      mergeMintImportSharedState({ key, progress: 10 + Math.trunc((100 * 0.8 * index) / totalLength) }); // 10-90%

      chunk = simplifiBalances.splice(0, chunkSize);
    }

    results = true;

    mergeMintImportSharedState({ key, progress: 100, [key]: { importedCount: totalLength } });
  } catch (error) {
    assert(false, error);
    mergeMintImportSharedState({ error: key, [key]: { error } });
  }

  return results;
};

export default importBalances;
